/**
 * @param populateOptions an array of properties you want to populate in the query.
 * @returns an array of population params. The index is used to make each param unique which would otherwise be ignored.
 * @example (['author', 'posts', 'comments']) => [["populate[0]","author"}], ["populate[1]","posts"}], ["populate[2]","comments"}]] ]
 */
export const formatPopulationParams = (populateOptions: string[]) =>
  populateOptions.map((option, index) => [`populate[${index}]`, option]);
